import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosCall, AxiosPost } from '../../../utils/axios';
import { getFbTrackingPayload } from "../../../utils/fbTracking";
import * as actions from './actions';

function* fetchRunes() {
  try {
    const result = yield call(AxiosCall, `/runas/get_runes/`);
    yield put(actions.fetchRunesSuccess(result.data.results));
  } catch (e) {
    yield put(actions.fetchRunesFailure({
      code: 'UNKNOWN',
      message: 'No pudimos cargar las runas. Recarga la página.',
    }));
  }
}

function* getIndexReading(action) {
  try {
    const result = yield call(AxiosPost, `/runas/get_index_reading/`, action.payload);
    const code = result.data?.response;
    if (code === 'READING_CONSUMED') {
      yield put(actions.getIndexReadingFailure({
        code,
        message: 'Ya realizaste 3 tiradas hoy. Vuelve mañana o activa el oráculo completo.',
      }));
      return;
    }
    if (code === 'NO_READINGS_AVAILABLE' || code === 'UNHANDLED_EXCEPTION') {
      yield put(actions.getIndexReadingFailure({
        code,
        message: 'No pudimos obtener tu lectura en este momento. Intenta de nuevo.',
      }));
      return;
    }
    yield put(actions.getIndexReadingSuccess(result.data.reading));
  } catch (e) {
    yield put(actions.getIndexReadingFailure({
      code: 'UNKNOWN',
      message: 'Ocurrió un error inesperado. Intenta de nuevo.',
    }));
  }
}

function* setIndexReadingLike(action) {
  try {
    yield call(AxiosPost, `/runas/set_index_reading_like/`, action.payload);
    yield put(actions.setIndexReadingLikeSuccess());
  } catch (e) {
    // non-critical
  }
}

function* requestThreeRuneEmail(action) {
  try {
    const result = yield call(AxiosPost, `/runas/create_public_threerunereading/`, action.payload);
    const code = result.data?.response;
    if (code === 'READING_CONSUMED') {
      yield put(actions.requestThreeRuneEmailFailure({
        code,
        message: 'Ya usaste tu tirada gratuita. Activa el oráculo completo para seguir.',
      }));
      return;
    }
    if (code === 'NO_READINGS_AVAILABLE' || code === 'UNHANDLED_EXCEPTION') {
      yield put(actions.requestThreeRuneEmailFailure({
        code,
        message: 'No pudimos procesar tu tirada. Intenta en unos minutos.',
      }));
      return;
    }
    yield put(actions.requestThreeRuneEmailSuccess());
  } catch (e) {
    yield put(actions.requestThreeRuneEmailFailure({
      code: 'UNKNOWN',
      message: 'Ocurrió un error inesperado. Intenta de nuevo.',
    }));
  }
}

function* createThreeRune(action) {
  try {
    const result = yield call(AxiosPost, `/runas/create_threerunecustomreading/`, action.payload);
    const code = result.data?.response;
    if (code === 'PERK_REQUIRED') {
      yield put(actions.createThreeRuneFailure({
        code,
        message: 'Necesitas activar el oráculo completo para recibir esta tirada.',
      }));
      return;
    }
    if (code === 'READING_CONSUMED') {
      yield put(actions.createThreeRuneFailure({
        code,
        message: 'Ya hiciste esta tirada hoy. Prueba con otras runas o vuelve mañana.',
      }));
      return;
    }
    if (code === 'NO_READINGS_AVAILABLE' || code === 'UNHANDLED_EXCEPTION') {
      yield put(actions.createThreeRuneFailure({
        code,
        message: 'No pudimos procesar tu tirada. Intenta de nuevo.',
      }));
      return;
    }
    yield put(actions.createThreeRuneSuccess(result.data.reading));
  } catch (e) {
    yield put(actions.createThreeRuneFailure({
      code: 'UNKNOWN',
      message: 'Ocurrió un error inesperado. Intenta de nuevo.',
    }));
  }
}

function* createPendingThreeRune(action) {
  try {
    const result = yield call(AxiosPost, `/runas/create_pending_threerunereading/`, action.payload);
    yield put(actions.createPendingThreeRuneSuccess(result.data.reading_id));
  } catch (e) {
    yield put(actions.createPendingThreeRuneFailure(e));
  }
}

function* runasCheckout(action) {
  try {
    const result = yield call(AxiosPost, `/runas/create_checkout/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.runasCheckoutSuccess());
    window.location.href = result.data.checkout_url;
  } catch (e) {
    yield put(actions.runasCheckoutFailure(e));
  }
}

function* runasPaypalOrder(action) {
  try {
    const result = yield call(AxiosPost, `/runas/create_paypal_order/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.runasPaypalOrderSuccess());
    window.location.href = result.data.approve_url;
  } catch (e) {
    yield put(actions.runasPaypalOrderFailure(e));
  }
}

function* runasVerify(action) {
  try {
    const result = yield call(AxiosPost, `/runas/verify_purchase/`, action.payload);
    yield put(actions.runasVerifyPurchaseSuccess(result.data));
  } catch (e) {
    yield put(actions.runasVerifyPurchaseFailure(e));
  }
}

function* runasVerifyPaypal(action) {
  try {
    const result = yield call(AxiosPost, `/runas/verify_paypal_purchase/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.runasVerifyPaypalSuccess(result.data));
  } catch (e) {
    yield put(actions.runasVerifyPaypalFailure(e));
  }
}

export default function* runasSaga() {
  yield all([
    takeLatest(actions.FETCH_RUNES_REQUEST, fetchRunes),
    takeLatest(actions.GET_INDEX_READING_REQUEST, getIndexReading),
    takeLatest(actions.SET_INDEX_READING_LIKE_REQUEST, setIndexReadingLike),
    takeLatest(actions.REQUEST_THREE_RUNE_EMAIL_REQUEST, requestThreeRuneEmail),
    takeLatest(actions.CREATE_THREE_RUNE_REQUEST, createThreeRune),
    takeLatest(actions.CREATE_PENDING_THREE_RUNE_REQUEST, createPendingThreeRune),
    takeLatest(actions.RUNAS_CHECKOUT_REQUEST, runasCheckout),
    takeLatest(actions.RUNAS_PAYPAL_REQUEST, runasPaypalOrder),
    takeLatest(actions.RUNAS_VERIFY_REQUEST, runasVerify),
    takeLatest(actions.RUNAS_VERIFY_PAYPAL_REQUEST, runasVerifyPaypal),
  ]);
}
